export default "__VITE_ASSET__Cfz5QgXc__"